import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const FONT_BODY = "'DM Sans', sans-serif";

const LEGAL_LINKS = [
  { key: 'privacyPolicy',           path: '/privacy-policy' },
  { key: 'termsAndConditions',      path: '/terms-and-conditions' },
  { key: 'disclaimer',              path: '/disclaimer' },
  { key: 'acceptableUsePolicy',     path: '/acceptable-use-policy' },
  { key: 'accessibilityStatement',  path: '/accessibility-statement' },
];

// Shared 5-link row (Privacy/Terms/Disclaimer/AUP/Accessibility) used both in
// the full marketing SiteFooter and the compact dashboard-sidebar footer, so
// the two never drift out of sync.
export default function LegalLinksRow({ dark = false, wrap = true, fontSize = '0.75rem' }) {
  const { t } = useTranslation();
  const color = dark ? 'rgba(13,27,42,0.55)' : 'rgba(255,255,255,0.4)';

  return (
    <nav aria-label={t('common.legal')} style={{
      display: 'flex', gap: '1rem', alignItems: 'center',
      flexWrap: wrap ? 'wrap' : 'nowrap',
    }}>
      {LEGAL_LINKS.map(link => (
        <Link
          key={link.key}
          to={link.path}
          style={{ color, fontSize, fontFamily: FONT_BODY, textDecoration: 'none', whiteSpace: 'nowrap' }}
        >
          {t(`common.${link.key}`)}
        </Link>
      ))}
    </nav>
  );
}
